import React from 'react';
import {BrowserRouter, Switch, useHistory} from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasUpload from './aidas-upload';
import AidasUploadDetail from './aidas-upload-detail';
import AidasUploadUpdate from './aidas-upload-update';
import AidasUploadDeleteDialog from './aidas-upload-delete-dialog';
const DebugRouter = ({ children }: { children: any }) => {
  const { location } = useHistory()

    /* eslint-disable no-console */
    console.log(
      `Route: ${location.pathname}${location.search}, State: ${JSON.stringify(location.state)}`,
    )
    /* eslint-enable no-console */


  return children
}
const Routes = ({ match }) => (
  <>
    <DebugRouter>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasUploadUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasUploadUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasUploadDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasUpload} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasUploadDeleteDialog} />
    </DebugRouter>
  </>
);

export default Routes;
